import React from 'react';
import { t } from 'ttag';
import { Heading } from '@components';
import quickHelpLinks from './quickHelpLinks';
import ReturnIcon from './icons/ReturnIcon';
import TrackAndTraceIcon from './icons/TrackAndTraceIcon';

function QuickHelpBox({ title, description, Icon, link, ArrowIcon }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="relative flex max-w-xs flex-col items-center rounded-xl bg-white p-4 pb-12 pt-12 text-black"
    >
      <div className="mb-6 flex h-12 w-12 items-center justify-center">
        <Icon className="h-12 w-12 text-black" />
      </div>
      <div className="leading-1 text-center text-base font-bold">
        {t(title)}
      </div>
      <p className="mb-4 max-w-[10rem] text-center text-sm leading-none text-dark-gray md:mb-12">
        {t(description)}
      </p>
      <span className="absolute bottom-4 right-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-green to-[#E0F65A] p-1 text-black transition-opacity ">
        {ArrowIcon}
      </span>
    </a>
  );
}

export default function QuickHelp() {
  const links = quickHelpLinks[window?.config?.language_code];

  if (!links) return null;

  const quickHelpData = [
    {
      title: t`Return package`,
      description: t`Steps to return your item`,
      Icon: ReturnIcon,
      link: links?.return,
      ArrowIcon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-arrow-right"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      )
    },
    {
      title: t`Track a package`,
      description: t`Enter the order number from your order confirmation`,
      Icon: TrackAndTraceIcon,
      link: links?.trackAndTrace,
      ArrowIcon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-arrow-up-right"
        >
          <path d="M7 7h10v10" />
          <path d="M7 17 17 7" />
        </svg>
      )
    }
  ];

  return (
    <section className="max-w-screen-sm rounded-xl">
      <Heading as="h4" className="mb-2 break-words text-2xl normal-case">
        {t`Quick help`}
      </Heading>
      <div className="grid grid-cols-2 gap-2 md:gap-4">
        {quickHelpData.map(({ title, description, Icon, link, ArrowIcon }) => (
          <QuickHelpBox
            key={title}
            title={title}
            description={description}
            Icon={Icon}
            link={link}
            ArrowIcon={ArrowIcon}
          />
        ))}
      </div>
    </section>
  );
}
